import mixpanel from 'mixpanel-browser'
import { mixpanelToken } from '@/components/utils/config'

mixpanel.init(mixpanelToken)

const identifyMixpanelUser = (uid) => {
  mixpanel.identify(uid)
  // console.log('identifyMixpanelUser', uid)
}

const createMixpanelUser = async ({ user, email }) => {
  mixpanel.identify(user.uid)
  mixpanel.people.set({
    ...user,
    $name: user.name,
    $email: email
  })
  // console.log('createMixpanelUser', user)
}

export default mixpanel
export { identifyMixpanelUser, createMixpanelUser }